import { Container  } from '@chakra-ui/react';
import type { ContainerProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const ContentContainer = ({ children, ...props }: PropsWithChildren<ContainerProps>) => {
	return (
		<Container
			maxW="breakpoint-xl"
			p={0}
			w="100%"
			{...props}
		>
			{children}
		</Container>
	);
};
